import React, { useState, useEffect, useCallback } from 'react'
import { v4 as uuidv4 } from 'uuid'
import {
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  InputAdornment,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
  useTheme,
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import DeleteIcon from '@mui/icons-material/Delete'
// import SendSharpIcon from "@mui/icons-material/SendSharp";
import ConvoInfoDialog from '../../components/convoInfo/ConvoInfo'
import MessageList from '../../components/MessageList'
import {
  getMessages,
  attachFile,
  deleteAttachment,
  sendMessage,
} from '../../services/messages' //api call
import { getParticipants } from '../../services/conversation'
import MessageEventsDialog from '../../components/MessageEventDialog'
import DataDialog from '../../components/MessageInfo'
import { useParams } from 'react-router-dom'

// interface Conversation {
//   convo_id: string
//   name: string
//   status: string
//   created_at?: string
//   created_by: string
//   is_auto_generated: boolean
//   email_message_id?: string
// }

interface Message {
  message_id: string
  convo_id: string
  sender_id: string
  body: string
  has_attachments: boolean | null
  status: string
  parent_message_id: string | null
  created_at: string
  attachments?: {
    type: string
    attachment_id?: string
    attachment_url: string
  }[]
  email_message_id?: string | undefined | null
}

interface Participant {
  participant_value: string
  participant_channel: string
  participant_id: string
}

//seected files interface is a dictionalry like s3Key and File
interface ChatFile extends File {
  url: string
}

//no props just get convoId from url
const ConvoInterface: React.FC = () => {
  const { convoId } = useParams()
  const theme = useTheme()
  const menuOptions = ['info', 'close conversation']

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openConvoInfo, setOpenConvoInfo] = useState(false)
  const [message, setMessage] = useState('')
  const [messages, setMessages] = useState<Message[]>([]) // State for messages
  const [currentPage, setCurrentPage] = useState(1) // State for current page
  const [hasMoreMessages, setHasMoreMessages] = useState(true) // State to track if more messages are available
  const [participants, setParticipants] = useState<Participant[]>([])
  const [openMessageEvents, setOpenMessageEvents] = useState(false)
  const [openViewMessage, setOpenViewMessage] = useState(false)
  const [emailMessageId, setEmailMessageId] = useState<string | null>(null)
  const [selectedMessageId, setSelectedMessageId] = useState<string | null>(
    null
  )
  const [selectedMessage, setSelectedMessage] = useState<string | null>(null)
  const [selectedFiles, setSelectedFiles] = useState<ChatFile[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [info, setInfo] = useState<string | null>(null)
  const [userEmail] = useLocalStorage('userEmail', '')

  const frequency = localStorage.getItem('frequency') || '0'

  const authorId = participants.find(
    (participant) => participant.participant_value === userEmail
  )?.participant_id

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleAddAttachment = () => {
    const fileInput = document.createElement('input')
    fileInput.type = 'file'
    fileInput.accept = 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv'
    fileInput.multiple = false

    fileInput.onchange = async (event: Event) => {
      const target = event.target as HTMLInputElement
      if (target.files && target.files.length > 0) {
        const file = target.files[0]

        if (convoId) {
          setLoading(true)
          try {
            const urls = await sendFilesToAPI(convoId, [file])
            if (urls) {
              const chatFile = file as ChatFile
              chatFile.url = urls[0]
              setSelectedFiles((prevFiles) => [...prevFiles, chatFile])
            }
          } catch (err) {
            setError('Failed to attach files')
          } finally {
            setLoading(false)
          }
        }
      }
    }

    fileInput.click()
  }

  const sendFilesToAPI = async (conversationId: string, files: File[]) => {
    try {
      const response = await attachFile(conversationId, files)
      if (response.success && response.data.urls) {
        console.log('Files attached successfully')
        return response.data.urls
      } else {
        throw new Error('Failed to attach files')
      }
    } catch (error) {
      setError('Error attaching files')
      return null
    }
  }

  const handleRemoveFile = (file: ChatFile) => {
    console.log(`Removing file: ${JSON.stringify(file)}`)
    setSelectedFiles((prevFiles) => prevFiles.filter((f) => f !== file))
    if (convoId) {
      deleteAttachment(convoId, file.url)
        .then((response) => {
          if (response.success) {
            console.log('Attachment deleted successfully')
          } else {
            throw new Error('Failed to delete attachment')
          }
        })
        .catch((error) => {
          setError(`Error deleting attachment: ${error}`)
        })
    }
  }

  //   const getSelectedConvo = () =>
  //     conversations?.find((convo) => convo.convo_id === convoId)

  const getSelectedConvoName = () => {
    //     const convo = getSelectedConvo()
    //     return convo ? convo.name : null
    return null //TODO: fix this
  }

  const isAutoGenerated = () => {
    //     const convo = getSelectedConvo()
    //     return convo ? convo.is_auto_generated : false
    return false //TODO: fix this
  }

  const handleMenuOptionClick = (option: string) => {
    if (option === 'info') {
      setOpenConvoInfo(true)
    } else if (option === 'close conversation') {
      console.log(`Closing conversation: ${convoId}`)
    }
    handleMenuClose()
  }

  const isAuthor = () => {
    //     const convo = getSelectedConvo()
    //     return convo ? convo.created_by === authorId : false
    return false //TODO: fix this
  }

  const getSenderId = () => {
    if (isAutoGenerated()) {
      const botId = participants.find((participant) =>
        participant.participant_value.includes('@play.trames.dev')
      )?.participant_id
      return botId
    }
    return authorId
  }

  const handleSendMessage = () => {
    const feMsgId = uuidv4()
    if (message.trim()) {
      const newMessage: Message = {
        message_id: feMsgId,
        convo_id: convoId!,
        sender_id: getSenderId() as string,
        body: message,
        has_attachments: selectedFiles.length > 0,
        status: 'pending',
        parent_message_id: null,
        created_at: new Date().toISOString(),
        attachments: selectedFiles.map((file) => ({
          type: file.type,
          attachment_url: file.url,
        })),
      }
      setMessages((prevMessages) => [...prevMessages, newMessage])
      setMessage('') // Clear message input
      setSelectedFiles([]) // Clear selected files

      sendMessage(convoId!, message, feMsgId)
        .then((response) => {
          if (response.success) {
            console.log('Message sent successfully')
            setMessages((prevMessages) => {
              const updatedMessages = prevMessages.map((msg) => {
                if (msg.message_id === feMsgId) {
                  return { ...msg, status: 'sent' }
                }
                return msg
              })
              return updatedMessages
            })
          } else {
            throw new Error('Failed to send message')
          }
        })
        .catch((error) => {
          setError(`Error sending message: ${error.message}`)
        })
    } else {
      setError('Please enter a message')
    }
  }

  const handleNewMessageEvent = useCallback(
    (event: MessageEvent) => {
      console.log('Received new message event')
      if (!event.data) return
      const newMessage = JSON.parse(event.data)
      console.log('New message:', newMessage)

      setMessages((prevMessages) => {
        if (
          prevMessages.some((msg) => msg.message_id === newMessage.messageId)
        ) {
          return prevMessages
        }
        const message = {
          message_id: newMessage.messageId,
          convo_id: convoId!,
          sender_id: newMessage.sender_id,
          body: newMessage.message,
          has_attachments: newMessage.hasAttachment,
          status: 'received',
          parent_message_id: null,
          created_at: new Date().toISOString(),
          attachments: newMessage.attachments ? newMessage.attachments : [],
        }

        // Return the new array with the added message
        return [...prevMessages, message]
      })
    },
    [convoId] // Dependencies for the callback
  )

  const fetchParticipantsAndMessages = async (page = 1) => {
    try {
      const participantsResponse = await getParticipants(convoId as string)
      if (participantsResponse.success) {
        setParticipants(participantsResponse.data.participants)
      } else {
        console.error('Failed to fetch participants')
      }

      const messagesResponse = await getMessages(convoId as string, 10, page)
      if (messagesResponse.success) {
        if (page === 1 || currentPage === 1) {
          console.log('Setting messages:', messagesResponse.data.messages)
          setMessages(messagesResponse.data.messages)
        } else {
          setMessages((prevMessages) => {
            const newMessages = messagesResponse.data.messages
            return [...newMessages, ...prevMessages]
          })

          console.log('Messages:', messages.length)
        }
        if (messagesResponse.data.messages.length < 10) {
          setHasMoreMessages(false) // No more messages available
        }
      } else {
        console.error('Failed to fetch messages')
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleScroll = (e: React.UIEvent<HTMLElement>) => {
    const { scrollTop } = e.currentTarget
    console.log('hasMoreMessages:', hasMoreMessages)
    if (scrollTop === 0 && hasMoreMessages && !loading) {
      setLoading(true)
      fetchParticipantsAndMessages(currentPage + 1).then(() => {
        setCurrentPage((prevPage) => prevPage + 1)
        setLoading(false)
      })
    }
  }

  useEffect(() => {
    if (!convoId) return
    setCurrentPage(1)
    setHasMoreMessages(true)
    fetchParticipantsAndMessages(1)

    //if frequency not equal to 0, set interval to fetch messages
    if (parseInt(frequency) !== 0) {
      const interval = setInterval(() => {
        if (isAutoGenerated()) {
          fetchParticipantsAndMessages(1)
        }
      }, parseInt(frequency) * 1000)
      return () => clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [convoId])

  // listen to a sse event /api/v1/conversations/subscribe/:convoId

  useEffect(() => {
    if (!convoId) return
    if (isAutoGenerated()) {
      console.log('Cannot subscribe to auto-generated conversation')
      return
    }
    console.log('Subscribing to conversation:', convoId)

    const eventSource = new EventSource(
      `https://id-10-server-dev.azurewebsites.net/id10/internals/conversations/subscribe/${convoId}`
    )

    eventSource.onmessage = (event) => {
      // const message = JSON.parse(event.data);
      console.log('Received message:', event)
    }

    eventSource.onerror = (error) => {
      console.error('EventSource failed')
      if (error?.type === 'error') {
        setError('Connection lost, reconnecting...')
      }
    }

    eventSource.addEventListener('newMessage', handleNewMessageEvent)

    eventSource.addEventListener('close', (event) => {
      console.log('Received close event:', event)
      eventSource.close()
    })

    eventSource.addEventListener('status', (event) => {
      console.log('Received status event:', event)
      setInfo(`Server status: ${event.data}`)
    })

    return () => eventSource.close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [convoId])

  const renderSecondaryAppBar = () => (
    <AppBar
      position='static'
      sx={{
        boxShadow: 'none',
        borderBottom: 1,
        borderColor: 'divider',
        color: theme.palette.action.active,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Toolbar>
        <Typography variant='h6' sx={{ flexGrow: 1 }}>
          {getSelectedConvoName()}
        </Typography>
        <IconButton
          edge='end'
          color='inherit'
          onClick={handleMenuClick}
          style={{ outline: 'none', boxShadow: 'none' }}
        >
          <MoreVertIcon />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          {menuOptions.map((option) => (
            <MenuItem
              key={option}
              onClick={() => handleMenuOptionClick(option)}
              disabled={option === 'close conversation' && !isAuthor()}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  )

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // take isAutoGenerated as a prop and disable the button if it is true
  const renderMessageInput: React.FC<{ isAutoGenerated: boolean }> = ({
    isAutoGenerated,
  }) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        bgcolor: 'background.paper',
        p: 2,
      }}
    >
      {/* Display attached files */}
      {selectedFiles.length > 0 && (
        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            bgcolor: 'background.paper',
            p: 1,
            zIndex: 1,
            top: -50,
            width: '95%',
          }}
        >
          {selectedFiles.map((file, index) => (
            <Box key={index} display='flex' alignItems='center' mr={1} mb={1}>
              <Box>{file.name}</Box>
              <IconButton onClick={() => handleRemoveFile(file)} size='small'>
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}
        </Box>
      )}

      <TextField
        fullWidth
        variant='outlined'
        placeholder={
          isAutoGenerated
            ? 'Send a message to reply-all to this email conversation'
            : 'Type a message...'
        }
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSendMessage()
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <IconButton
                style={{ outline: 'none', boxShadow: 'none' }}
                onClick={() => handleAddAttachment()}
                disabled={selectedFiles.length >= 3 || loading}
              >
                {loading ? (
                  <CircularProgress size={24} />
                ) : (
                  <AddCircleIcon sx={{ fontSize: 35 }} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
        // disabled={isAutoGenerated}
      />
      {/* Display error message */}
      <Snackbar
        open={!!error}
        autoHideDuration={2000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setError(null)}
          severity='error'
          sx={{ width: '100%' }}
        >
          {error}
        </Alert>
      </Snackbar>

      {/* Display info message */}
      <Snackbar
        open={!!info}
        autoHideDuration={2000} // Hide after 6 seconds
        onClose={() => setInfo(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setInfo(null)}
          severity='info'
          sx={{ width: '100%' }}
        >
          {info}
        </Alert>
      </Snackbar>
    </Box>
  )

  //   if (!conversations) {
  //     return (
  //       <Box
  //         sx={{
  //           display: 'flex',
  //           justifyContent: 'center',
  //           alignItems: 'center',
  //           flexGrow: 1,
  //           position: 'absolute',
  //           top: '50%',
  //           left: '50%',
  //           transform: 'translate(-50%, -50%)',
  //         }}
  //       >
  //         <Typography variant='h6'>
  //           No conversations to display, try creating one
  //         </Typography>
  //       </Box>
  //     )
  //   }

  if (!convoId) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Typography variant='h6'>Select a conversation</Typography>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
      id='chat-interface'
    >
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
        id='chat-interface-content'
      >
        {renderSecondaryAppBar()}

        <Box
          sx={{ flexGrow: 1, p: 3, overflowY: 'auto' }}
          id='message-list'
          onScroll={handleScroll}
        >
          <MessageList
            messages={messages}
            participants={participants}
            selectedConvo={convoId}
            setSelectedMessage={setSelectedMessage}
            setSelectedMessageId={setSelectedMessageId}
            selectedMessageId={selectedMessageId}
            setopenMessageEvents={setOpenMessageEvents}
            setopenViewMessage={setOpenViewMessage}
            setEmailMessageId={setEmailMessageId}
            emailMessageId={emailMessageId}
            onScroll={handleScroll}
          />
          {loading && <CircularProgress />}
        </Box>
        {renderMessageInput({
          isAutoGenerated: isAutoGenerated(),
        })}
      </Box>

      <ConvoInfoDialog
        open={openConvoInfo}
        onClose={() => setOpenConvoInfo(false)}
      />
      <MessageEventsDialog
        open={openMessageEvents}
        onClose={() => setOpenMessageEvents(false)}
        message={selectedMessage ? selectedMessage : ''}
        conversationId={convoId}
        messageId={selectedMessageId || ''}
      />
      <DataDialog
        open={openViewMessage}
        onClose={() => setOpenViewMessage(false)}
        emailMessageId={emailMessageId || null}
      />
    </Box>
  )
}

export default ConvoInterface
